import { Target, Sparkles, Globe, Plane, Megaphone, Workflow } from "lucide-react";

const SERVICES = [
  { num: "01", icon: Target, title: "Lead Generation that Books Flats", desc: "Performance campaigns engineered for site-visit-ready buyers — not vanity clicks. Meta, Google, YouTube and DV360, with CPL tracked to closure." },
  { num: "02", icon: Sparkles, title: "RERA-Compliant Creative & Branding", desc: "Project logos, brand kits, brochures, hoardings and pitch decks reviewed against state RERA guidelines before going live. Beautiful, lawful, sellable." },
  { num: "03", icon: Globe, title: "Project Microsites & Landing Pages", desc: "Sub-1-second-load microsites with WhatsApp lead capture, EMI calculators, and pixel-tracked CTAs. Built to convert paid traffic at industry-leading rates." },
  { num: "04", icon: Plane, title: "Drone, 3D & Cinematic Walkthroughs", desc: "Cinematic site shoots, drone flyovers, AI-powered 3D walkthroughs and lifestyle films. Show buyers the home before the keys are handed over." },
  { num: "05", icon: Megaphone, title: "Social, Influencer & Broker Engine", desc: "Always-on Instagram, YouTube Shorts, finance creators and local channel-partner activations that move inventory in 30, 60 and 90-day sprints." },
  { num: "06", icon: Workflow, title: "CRM, WhatsApp & Sales Enablement", desc: "Lead routing in <60 seconds, WhatsApp Business automation, broker dashboards and sales SOPs that turn marketing spend into bookings." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 sm:py-32 border-t border-white/5">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-8 mb-14">
          <div>
            <div className="font-mono text-xs text-[#d4ff4f] mb-3 tracking-[0.2em]">#खुलजा_सिम_सिम</div>
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 mb-4">/ Our Services</div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
              One engine.<br />
              Every <span className="italic text-[#d4ff4f]">lever</span><br />
              real estate needs.
            </h2>
          </div>
          <p className="max-w-md text-white/60 text-base leading-relaxed self-end">
            From the first hoarding to the final possession letter — we run the entire marketing & demand-gen stack so your sales team only has one job: <span className="text-white">closing buyers.</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="card-hover relative rounded-2xl border border-white/10 bg-white/[0.02] p-7 hover:bg-white/[0.04] group"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-12 h-12 rounded-xl bg-[#d4ff4f]/10 border border-[#d4ff4f]/20 flex items-center justify-center group-hover:bg-[#d4ff4f] group-hover:text-black transition">
                    <Icon className="w-5 h-5 text-[#d4ff4f] group-hover:text-black" />
                  </div>
                  <span className="font-mono text-xs text-white/40">{s.num}</span>
                </div>
                <h3 className="font-display text-2xl tracking-tight leading-tight mb-3">{s.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>
                <div className="mt-6 h-px w-0 group-hover:w-full bg-[#d4ff4f] transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
